import { InvalidArgumentError } from '../error/InvalidArgumentError';
export function validateStringArgumentNotEmpty(value, valueName) {
    if (value === '') {
        throw new InvalidArgumentError(valueName, `'${valueName}' is required, and can't be empty.`);
    }
}
